import { stringify } from 'query-string';
import { Dict } from '../../models';
import { ApiResponse, ListSort, PaginatedApiResponse } from '../models';
import { LeadConfiguration } from '../models/configuration';
import * as http from './http';
import ApiService from './service';

export class VINService extends ApiService {
  public async getVINRequests(
    data: {
      page: number;
      search?: string;
      perPage: number;
    } & ListSort &
      Dict
  ): Promise<
    PaginatedApiResponse<LeadConfiguration> & { lastUpdatedAt: Date }
  > {
    const url = `${this.apiDomain}/api/vin/requests`;
    const response = await http.post<PaginatedApiResponse<LeadConfiguration>>(
      url,
      data,
      this.store
    );
    return { ...response?.data, lastUpdatedAt: new Date() };
  }
  public async getVINRequestDetails(
    leadId: string,
    configId: string,
    requestId?: string
  ): Promise<
    ApiResponse<{
      current: LeadConfiguration;
      configurations: LeadConfiguration[];
    }>
  > {
    const url = `${this.apiDomain}/api/vin/request?${stringify({
      leadId,
      configId,
      requestId,
    })}`;
    const response = await http.get<
      ApiResponse<{
        current: LeadConfiguration;
        configurations: LeadConfiguration[];
      }>
    >(url, this.store);
    return response?.data;
  }

  public async acceptVINRequest(data: {
    leadId: string;
    configId: string;
    vehicleId: string;
    extensionRequest?: boolean;
    toDate: Date;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/vin/request/accept`;
    await http.put(url, data, this.store);
  }

  public async cancelVINRequest(data: {
    leadId: string;
    configId: string;
    vehicleId: string;
    extensionRequest?: boolean;
    isPreVin?: boolean;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/vin/request/cancel`;
    await http.put(url, data, this.store);
  }

  public async rejectVINRequest(data: {
    leadId: string;
    configId: string;
    vehicleId: string;
    extensionRequest?: boolean;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/vin/request/reject`;
    await http.put(url, data, this.store);
  }

  public async releaseVINNumber(data: {
    leadId: string;
    configId: string;
    vehicleId: string;
    isPreVin?: boolean;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/vin/release`;
    await http.post(url, data, this.store);
  }
  public async extendVINNumber(data: {
    leadId: string;
    configId: string;
    vehicleId: string;
    toDate: Date;
    request?: boolean;
    isPreVin?: boolean;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/vin/extension`;
    await http.post(url, data, this.store);
  }

  public async updateVehicleDeliveryStatus(data: {
    leadId: string;
    configId: string;
    markAsDelivered: boolean;
    deliveredDate: Date;
    deliveredTime?: string;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/vin/update-status/delivery`;
    await http.put(url, data, this.store);
  }
  public async updateVehicleRegistrationStatus(data: {
    leadId: string;
    configId: string;
    status: string;
    submittedDate: Date;
    registrationNo?: string;
  }): Promise<void> {
    const url = `${this.apiDomain}/api/vin/update-status/registration`;
    await http.put(url, data, this.store);
  }

  public async preFitAccessories(data: {
    accessories: string[];
    vinNumber: string;
  }) {
    const url = `${this.apiDomain}/api/vin/prefit-accessories/`;
    const response = await http.put(url, data, this.store);
    return response?.data;
  }

  public async removeAccessories(data: { id: string; accessoryId: string }) {
    const url = `${this.apiDomain}/api/vin/${data.id}/remove-accessories/${data.accessoryId}`;
    const response = await http.remove(url, this.store);
    return response?.data;
  }
}
